export const PAGE = 'page'
export const COLLECTION = 'collection'
export const DRAWER = 'drawer'
export const SAMPLE_MINERAL = 'mineral'
export const SAMPLE_FOSSIL = 'fossil'
export const SAMPLE_ORE = 'ore'
export const SAMPLE_ROCK = 'rock'
export const TOUR = 'tour'
export const JOB = 'job'
